import React, { FunctionComponent } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { Grid } from 'semantic-ui-react';
import { Route, Switch } from 'react-router-dom';
import { RouteChildrenProps } from 'react-router';
import classnames from 'classnames';
import withStyles from 'react-jss';
import { pathOr } from 'ramda';

import VenueTypeFilter from './components/VenueTypeFilter';
import CashbackSegmentFilter from './components/CashbackSegmentFilter';
import ShowKeyMetricsDeltas from './components/ShowKeyMetricsDeltas';

import { GET_COUNT, GET_IS_OPEN } from './Filters.queries';
import styles from './Filters.styles';

import { ClassProp } from 'helpers/types';

type Styles = ClassProp<typeof styles>;

type Props = {
  classes: Styles;
};

const MerchantDetails = (classes: Styles, count: number) => (
  <div className={classes.merchantDetailsFilters}>
    <VenueTypeFilter count={count} />
    <CashbackSegmentFilter />
    <ShowKeyMetricsDeltas />
  </div>
);

const Filters: FunctionComponent<Props> = ({ classes }) => {
  const isOpenPayload = useQuery(GET_IS_OPEN);
  const filterCountPayload = useQuery(GET_COUNT);

  const filtersIsOpen = pathOr(false, ['data', 'filtersIsOpen'], isOpenPayload);
  const filterCount = pathOr(0, ['data', 'filterCount'], filterCountPayload);

  const renderMerchantDetails = (routeProps: RouteChildrenProps) =>
    MerchantDetails(classes, filterCount);

  return (
    <Grid.Row className={classnames(classes.filters, { filtersIsOpen })}>
      <div className={classnames(classes.container, { filtersIsOpen })}>
        <Switch>
          <Route
            exact
            render={renderMerchantDetails}
            path={[
              '/merchant/:merchantId/overview/:merchantName',
              '/:merchantName/overview',
            ]}
          />
        </Switch>
      </div>
    </Grid.Row>
  );
};

export default withStyles(styles)(Filters);
